import { useCallback } from 'react';

import type { AnyObject } from '../../../../../types';
import { useAtomicScreen } from '../../../context/AtomicScreenContext';
import { useLogAnalyticsEvent } from '../../../../../hooks/useLogAnalyticsEvent';

export const useLogClickBanner = (logging: AnyObject) => {
  const screen = useAtomicScreen();
  const logAnalyticsEvent = useLogAnalyticsEvent();

  const logClickBannerAll = useCallback(() => {
    logAnalyticsEvent({
      name: 'CLICK_BANNER',
      analytics: {
        ...logging.analytics,
        ...(screen != null && { SCREEN: screen }),
      },
      ably_only_log: logging.ably_only_log as AnyObject,
    });
  }, [logAnalyticsEvent, logging, screen]);

  const logClickBannerItem = useCallback(
    (itemLogging: AnyObject) => {
      logAnalyticsEvent({
        name: 'CLICK_BANNER',
        analytics: {
          ...logging.analytics,
          ...itemLogging.analytics,
          ...(screen != null && { SCREEN: screen }),
        },
        ably_only_log: {
          ...(logging.ably_only_log as AnyObject),
          ...(itemLogging.ably_only_log as AnyObject),
        },
      });
    },
    [logAnalyticsEvent, logging, screen],
  );

  return { logClickBannerAll, logClickBannerItem };
};
